import api from "../utils/api";
import moment from "moment";
import {
  DASHBOARD_FAILED,
  DASHBOARD_SUCCESS,
  HEALTH_DASHBOARD_FAILED,
  HEALTH_DASHBOARD_SUCCESS,
  PERFORMANCE_DASHBOARD_FAILED,
  PERFORMANCE_DASHBOARD_SUCCESS,
  REQUEST_DASHBOARD,
  REQUEST_HEALTH_DASHBOARD,
  REQUEST_PERFORMANCE_DASHBOARD,
  REQUEST_SAFETY_DASHBOARD,
  REQUEST_SECURITY_DASHBOARD,
  SAFETY_DASHBOARD_FAILED,
  SAFETY_DASHBOARD_SUCCESS,
  SECURITY_DASHBOARD_FAILED,
  SECURITY_DASHBOARD_SUCCESS,
} from "./types";

export const loadDashboard = () => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_DASHBOARD });
    const { data } = await api.get(`/dashboard`);
    dispatch({ type: DASHBOARD_SUCCESS, payload: data.data });
  } catch (error) {
    console.log(error);
    dispatch({ type: DASHBOARD_FAILED });
  }
};

// export const loadHealthDashboard = (params) => async (dispatch) => {
//   try {
//     dispatch({ type: REQUEST_HEALTH_DASHBOARD });
//     const { data } = await api.get(`/data/health?${params}`);
//     console.log(data);
//     dispatch({ type: HEALTH_DASHBOARD_SUCCESS, payload: data.data });
//   } catch (error) {
//     console.log(error);
//     dispatch({ type: HEALTH_DASHBOARD_FAILED });
//   }
// };

export const loadHealthDashboard = (building, floor) => async (dispatch) => {
  try {
    let body = {
      gauges: [
        {
          name: "Temperature",
          label: "Temperature",
          arcsLength: "0.1,0.1,0.1",
          colors: "red,yellow,#82f61d",
          unit: "°C",
          max: 48,
        },
        {
          name: "AQI",
          label: "Air Quality",
          arcsLength: "0.1,0.1,0.1",
          colors: "red,yellow,#82f61d",
          unit: "",
          max: 500,
        },
        {
          name: "Relative_Humidity",
          label: "Humidity",
          arcsLength: "0.1,0.1,0.1",
          colors: "red,yellow,#82f61d",
          unit: "%",
          max: 100,
        },
      ],
      graphs: [
        {
          name: "Noise_Level",
          label: "Noise Level",
          color: "#FEC14B",
          unit: "db",
          exponential: false,
        },
        {
          name: "Light",
          label: "Light",
          color: "#2BDF9E",
          unit: "lux",
          exponential: false,
        },
      ],
      // Default/ Current setting for data range for 5 days
      // From: 5 days ago 12pm To: today 12pm
      between: `${moment().subtract(3, "days")}--${moment()}`,
      floor,
      building,
    };
    dispatch({ type: REQUEST_HEALTH_DASHBOARD });
    const { data } = await api.post(`/dashboard/health`, body);
    dispatch({ type: HEALTH_DASHBOARD_SUCCESS, payload: data });
  } catch (error) {
    console.log(error);
    dispatch({ type: HEALTH_DASHBOARD_FAILED });
  }
};

export const loadOccupancyDashboard = (building, floor) => async (dispatch) => {
  try {
    let body = {
      gauges: [
        {
          name: "NumberOfPersons",
          label: "Space Utilization",
          colors: "#f00,#ffff00,lawngreen",
          unit: "%",
          max: 100,
        },
        {
          name: "NumberOfPersons",
          label: "Occupancy Utilization",
          colors: "#f00,#ffff00,lawngreen",
          unit: "%",
          max: 100,
        },
        {
          name: "NumberOfPersons",
          label: "Occupancy Density",
          colors: "#f00,#ffff00,lawngreen",
          unit: ":100 sf",
          max: 40,
        },
      ],
      graphs: [
        {
          name: "NumberOfPersons",
          label: "Number of People",
          color: "#FEC14B",
          exponential: false,
        },
        {
          name: "NumberOfEmptySeats",
          label: "Number of Seat",
          color: "#2BDF9E",
          exponential: false,
        },
      ],
      between: `${moment().subtract(3,'days')}--${moment()}`,
      floor,
      building,
    };
    dispatch({ type: REQUEST_PERFORMANCE_DASHBOARD });
    const { data } = await api.post(`/dashboard/occupancy`, body);
    if (data.subscribed) {
      dispatch({ type: PERFORMANCE_DASHBOARD_SUCCESS, payload: data });
    } else {
      dispatch({ type: PERFORMANCE_DASHBOARD_FAILED, payload: data });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: PERFORMANCE_DASHBOARD_FAILED });
  }
};
